// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__30u04","bigColWidth":"Table_bigColWidth__308sb","biggerColWidth":"Table_biggerColWidth__3EgyY","row":"Table_row__HWw0m","col":"Table_col__1_yzI"};